import { createSelector } from '@reduxjs/toolkit';
import { CERTIFICATE_DESIGNS } from './constants';
import { selectOrderID } from '../../../../store/payment/selectors';
import type { CertificateState } from './slice';
import { name } from './slice';

export const certificateStateSelf = (state): CertificateState => state[name];

export const getCertHolder = createSelector(
  certificateStateSelf,
  (state) => state.holder,
);

export const getCertDesignName = createSelector(
  certificateStateSelf,
  (state) => state.design,
);
export const getCertDesign = createSelector(
  getCertDesignName,
  (design) => CERTIFICATE_DESIGNS[design],
);

export const getCertText = createSelector(
  certificateStateSelf,
  (state) => state.text,
);
export const getCertShippingType = createSelector(
  certificateStateSelf,
  (state) => state.shippingType,
);
export const getIsCertificateCreated = createSelector(selectOrderID, Boolean);

export const getCertLink = createSelector(
  certificateStateSelf,
  (state) => state.link,
);
